module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/033-saint-kitts-and-nevis-77cf9f08ac5e179bd10abcb3ee8af8b4.svg";